var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"pl-2":"","pt-2":"","pr-2":"","pb-2":"","row":""}},[_c('v-flex',{attrs:{"xs4":"","lg2":""}},[_c('SimpleCard',[_c('ExportAccountTripsBox',{attrs:{"exportSettings":_vm.exportSettings}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }